import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/fonts/font.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)
Vue.config.productionTip = false
import * as echarts from 'echarts'
import 'echarts-gl' // 3d图表库
Vue.prototype.$echarts = echarts
import axios from '@/utils/axios'; 
Vue.prototype.$http = axios;
import BUS from '@/utils/bus'; 
Vue.prototype.$bus = BUS;
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
import './assets/js/seamscroll.js'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
